import * as React from "react";
import { FetchWithAuth } from "digimaker-ui/util";
import List from "digimaker-ui/List";
import { Link } from "react-router-dom";
import Browse from "digimaker-ui/Browse";
import util from "digimaker-ui/util";
import { Dialog } from "digimaker-ui/util";
import Registry from "digimaker-ui/Registry";
import { Modal, Button } from "react-bootstrap";

export default class User extends React.Component<
  { content: any },
  {
    browse: boolean;
    data: any;
    roles: any;
    selectedRole: any;
    roleIdentifierList: any;
    roleIdentifier: string;
    parameters: any;
    names: any;
    name: string;
  }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      browse: false,
      data: "",
      roles: [],
      selectedRole: "",
      roleIdentifierList: [],
      roleIdentifier: "",
      parameters: {},
      names: [],
      name: "",
    };
  }

  componentDidMount() {
    this.fetchRoles();
  }

  fetchRoles() {
    FetchWithAuth("access/roles/" + this.props.content.cid).then((data) =>
      this.setState({ data: data.data == null ? [] : data.data }),
    );
  }

  fetchAllRoles() {
    FetchWithAuth("content/list/role?limit=0&orderby=field.title asc").then(
      (data) => this.setState({ roles: data.data }),
    );

    FetchWithAuth("access/allroles").then((data) =>
      this.setState({ roleIdentifierList: data.data }),
    );
  }

  addRole(e: any) {
    this.setState({ browse: true });
    this.fetchAllRoles();
  }

  unassignRole(e: any, roleId: any) {
    e.preventDefault();
    FetchWithAuth(
      "access/unassign/" + this.props.content.cid + "/" + roleId,
    ).then((data) => this.fetchRoles());
  }

  changeRoleIdentifier(identifier) {
    this.setState({ roleIdentifier: identifier });
  }

  setParameters(params, names) {
    this.setState({ parameters: params, names: names });
    let name = this.state.roleIdentifier + "-" + names.join("-");
    this.setState({ name: name });
  }

  submit() {
    let params = {};
    if (this.state.selectedRole) {
      params["role_id"] = parseInt(this.state.selectedRole);
    } else {
      params["title"] = this.state.name;
      params["role"] = this.state.roleIdentifier;
      params["parameters"] = this.state.parameters;
    }
    FetchWithAuth("access/assign/" + this.props.content.cid, {
      method: "POST",
      body: JSON.stringify(params),
    }).then((data) => {
      if (data.error == false) {
        this.setState({ browse: false });
        this.fetchRoles();
      }
    });
  }

  renderParameters(role: any) {
    let roleIdentifier = role.identifier;
    let Parameters = Registry.getComponent(
      "access:parameters-" + roleIdentifier,
    );
    if (Parameters) {
      return (
        <React.Suspense fallback="...">
          <Parameters mode="view" data={role.parameters} />
        </React.Suspense>
      );
    }

    return "";
  }

  render() {
    let config = {};
    if (!this.state.data) {
      return "";
    }

    let Parameters: any = null;
    if (this.state.roleIdentifier) {
      Parameters = Registry.getComponent(
        "access:parameters-" + this.state.roleIdentifier,
      );
    }

    return (
      <div className="block">
        <h3>
          Roles &nbsp;
          <a href="#" onClick={(e) => this.addRole(e)}>
            <i className="fas fa-plus"></i> Add
          </a>
          {this.state.browse && (
            <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.browse}
            >
              <Modal.Header>
                <Modal.Title>Select role</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <label>Choolse role: </label>
                  <select
                    onChange={(e) =>
                      this.setState({ selectedRole: e.target.value })
                    }
                  >
                    <option value="">New </option>
                    {this.state.roles.map((role: any) => (
                      <option value={role.cid}>{role.title}</option>
                    ))}
                  </select>
                </div>

                {!this.state.selectedRole && (
                  <div>
                    <div>
                      <div>
                        <label>Role:</label>
                        <select
                          className="form-control"
                          onChange={(e) =>
                            this.changeRoleIdentifier(e.target.value)
                          }
                        >
                          {this.state.roleIdentifierList.map((item: any) => (
                            <option>{item}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label>Name: </label>
                        <input
                          type="text"
                          placeholder="Input name"
                          className="form-control"
                          onChange={(e) =>
                            this.setState({ name: e.target.value })
                          }
                          value={this.state.name}
                        />
                      </div>
                      {Parameters && (
                        <fieldset>
                          <legend>Parameters:</legend>
                          <div>
                            <React.Suspense fallback="...">
                              <Parameters
                                mode="edit"
                                onChange={(params, names) =>
                                  this.setParameters(params, names)
                                }
                              />
                            </React.Suspense>
                          </div>
                        </fieldset>
                      )}
                    </div>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={() => this.submit()}>
                  Submit
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ browse: false })}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </h3>
        <ul>
          {this.state.data.map((item) => (
            <li>
              <Link to={"/main/" + item.id}>{item.name}</Link>
              {item.parameters && <span>, {this.renderParameters(item)}</span>}
              <a href="#" onClick={(e) => this.unassignRole(e, item.cid)}>
                <i className="icon icon-delete"></i>
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
